import { HttpClient } from '@adapters/HttpClient';

export interface ClientShop {
  id: number;
  name: string;
  channel_id: number;
  status: number; // 1 = active, 0 = inactive
  connect_data: {
    url?: string;
    subdomain?: string;
    team_id?: number;
  } | null;
  team_id: number;
  fulfillment: boolean;
  created_at: string;
  updated_at: string;
  last_synchronization: string | null;
  image: string | null; // URL de la imagen del canal (Shopify, WooCommerce, etc.)
  team?: {
    id: number;
    name: string;
  };
}

export interface ClientShopsResponse {
  data: ClientShop[];
  meta: {
    current_page: number;
    per_page: number;
    total: number;
  };
}

export class ClientShopsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getShopsByTeamId(teamId: number, page = 1, perPage = 25): Promise<ClientShopsResponse> {
    const params: Record<string, any> = {
      per_page: perPage,
      page,
      'advanced_filters[filters][0][column]': 'team_id',
      'advanced_filters[filters][0][operator]': 'in',
      'advanced_filters[filters][0][value]': teamId,
      'advanced_filters[logic]': 'AND',
    };

    const response = await this.httpClient.get<ClientShopsResponse>('/shops', params);
    return response;
  }
}
